/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var log = require('../../utils/logger')('splitio-engine:matcher');
var intersection = require('lodash/intersection');

function partOfMatcherContext(ruleAttr /*: array */) /*: Function */{
  return function partOfMatcher(runtimeAttr /*: array */) /*: boolean */{
    // If the intersection returns all of runtimeAttr elements, it is a part of ruleAttr
    var isPartOf = intersection(runtimeAttr, ruleAttr).length === runtimeAttr.length;

    log.debug('[partOfMatcher] ' + runtimeAttr + ' is part of ' + ruleAttr + '? ' + isPartOf);

    return isPartOf;
  };
}

module.exports = partOfMatcherContext;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/engine/matchers/part_of.js
// module id = 453
// module chunks = 11